export enum actionTypes {
    SET_WAS_LOGGED_IN = 'USER:WAS_LOGGED_IN',
    SET_ALL_PLAYER_TAGS = 'USER:SET_ALL_PLAYER_TAGS',
    UPDATE_PLAYER_TAGS = 'USER:UPDATE_PLAYER_TAGS',
    REMOVE_PLAYER_TAG = 'USER:REMOVE_PLAYER_TAG',
    SET_IS_ADA_LOADED = 'USER:SET_IS_ADA_LOADED',
}
